export default [
  "0-9",
  "A-Z",
  "a-z",
  "А-Я",
  "а-я",
  "Α-ΡΣ-Ω",
  "α-ω",
  "A-Za-z0-9",
  "FPTVWYfrvwy",
  "aáàâåäãæbcçdðeéèêëfghiíìîïjklmnñoóòôöõøpqrstuúùûüvwxyýÿzþ",
  "aáàăâåäãąāæbcćĉčċçdďđðeéèĕêěëėęēfgğĝġģhĥħiíìĭîïĩįīĳıjĵkķlĺľļłŀmnńňñņŋoóòŏôöőõøōœpqĸrŕřŗsśŝšştťţŧuúùŭûůüűũųūvwŵxyýŷÿÿzźžżþ",
  ",.",
  ";:",
  "-–—+",
  "|fi|fj|fl|ff|ffi|ffl|fb|fh|fk|ft|",
  "@¡!¿?",
  "@“”‘’",
  "@“”„”„“””",
  "@|“_,”|”_”:|„_”,|„_“.|",
  "@\"\"''",
  "@()[]{}<>",
];
